import { useMutation } from "@tanstack/react-query";

import fetchJSON from "../../helpers/restApiClient";
import { PAYMENT_SECRET_KEY } from "../../constants/config";
import { getPunchPaymentUrl } from "../../constants/regionConfig";

import {
  ONLINE_PAYMENT_METHOD,
} from "../../constants/constants";

const punchPayment = async ({ amount, order_id, provider_id, region_id }) => {
  return fetchJSON(getPunchPaymentUrl(region_id), {
    method: "POST",
    headers: {
      "secret-key": PAYMENT_SECRET_KEY,
    },
    body: {
      order_id,
      amount,
      payment_mode_details: {
        provider_id: provider_id,
        payment_mode: ONLINE_PAYMENT_METHOD,
      },
    },
  }).then((response) => response.data);
};

export const usePunchPayment = (options) =>
  useMutation({
    mutationFn: punchPayment,
    ...options,
  });
